import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import Button from '@/components/common/Button/Button';
import { useAbandonUpliftFile } from '../../hooks/useAbandonUpliftFile';
import { useGetUploadedUpliftFiles } from '../../hooks/useGetUploadedUpliftFiles';
import { UPLIFT_UPLOADED_FILES_PER_PAGE } from '@/config/common.config';
import { useAddQueryToUrl } from '@/components/common/TagTabs/useAddQueryToUrl';
import styles from './grid-components.module.scss';

export default function AbandonButton({ data }: ICellRendererParams) {
  const { abandonFile } = useAbandonUpliftFile();
  const { getUploadedFiles } = useGetUploadedUpliftFiles();
  const { getValue } = useAddQueryToUrl();
  const currentPage = parseInt(getValue('page') ?? '1', 10);

  const updateList = async () => {
    getUploadedFiles(currentPage, UPLIFT_UPLOADED_FILES_PER_PAGE);
  };

  const onAbandon = () => {
    abandonFile(data!.id, updateList);
  };

  return (
    <div className={styles.btnContainer}>
      <Button
        onClick={onAbandon}
        buttonSize='small'
      >
        Abandon
      </Button>
    </div>
  );
}
